// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"578":"7a6de484","871":"00b6c417"}[chunkId] + ".css";
};